import { render, staticRenderFns } from "./VerificationOTPLogin.vue?vue&type=template&id=67f01d4a&lang=html"
import script from "./VerificationOTPLogin.vue?vue&type=script&lang=js"
export * from "./VerificationOTPLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports